// Generated by Melange

import * as Cn from "../../../../../vendored/classnames/Cn.js";
import * as Curry from "melange.js/curry.js";
import * as JsxRuntime from "react/jsx-runtime";

function ListWithPreview$Placeholder(Props) {
  let children = Props.children;
  return JsxRuntime.jsx("div", {
    children: children,
    className: "w-full h-full flex justify-center items-center"
  });
}

const Placeholder = {
  make: ListWithPreview$Placeholder
};

function ListWithPreview(Props) {
  let className = Props.className;
  let listOpt = Props.list;
  let previewOpt = Props.preview;
  let listIsLargerOpt = Props.listIsLarger;
  const list = listOpt !== undefined ? listOpt : (function (param) {
      return null;
    });
  const preview = previewOpt !== undefined ? previewOpt : (function (param) {
      return null;
    });
  const listIsLarger = listIsLargerOpt !== undefined ? listIsLargerOpt : false;
  const className$1 = Cn.fromList({
    hd: Cn.take(className),
    tl: {
      hd: Cn.fromList({
        hd: "h-full grid items-stretch",
        tl: {
          hd: listIsLarger ? "grid-cols-7-5" : "grid-cols-5-7",
          tl: /* [] */ 0
        }
      }),
      tl: /* [] */ 0
    }
  });
  const list$1 = Curry._1(list, undefined);
  const preview$1 = Curry._1(preview, undefined);
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx("div", {
        children: list$1,
        className: "col-start-1 col-end-2 relative flex flex-col"
      }),
      JsxRuntime.jsx("div", {
        children: preview$1,
        className: "col-start-2 col-end-3 border-l border-gray-main"
      })
    ],
    className: className$1
  });
}

const make = ListWithPreview;

export {
  Placeholder,
  make,
}
/* react/jsx-runtime Not a pure module */
